var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8989_34418",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    width: 24,
    height: 24,
    transform: "rotate(90 24 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8989_34418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.64866 9.30039L15.3487 9.30039L11.9987 5.95039L8.64866 9.30039ZM8.24866 8.72539L11.4737 5.50039C11.557 5.41706 11.6403 5.35872 11.7237 5.32539C11.807 5.29206 11.8987 5.27539 11.9987 5.27539C12.0987 5.27539 12.1903 5.29206 12.2737 5.32539C12.357 5.35872 12.4403 5.41706 12.5237 5.50039L15.7487 8.72539C15.982 8.95872 16.0362 9.22956 15.9112 9.53789C15.7862 9.84622 15.557 10.0004 15.2237 10.0004L8.77366 10.0004C8.44032 10.0004 8.21116 9.84622 8.08616 9.53789C7.96116 9.22956 8.01532 8.95872 8.24866 8.72539ZM8.24866 15.2754C8.01532 15.0421 7.96115 14.7712 8.08616 14.4629C8.21116 14.1546 8.44032 14.0004 8.77366 14.0004L15.2237 14.0004C15.557 14.0004 15.7862 14.1546 15.9112 14.4629C16.0362 14.7712 15.982 15.0421 15.7487 15.2754L12.5237 18.5004C12.4403 18.5837 12.357 18.6421 12.2737 18.6754C12.1903 18.7087 12.0987 18.7254 11.9987 18.7254C11.8987 18.7254 11.807 18.7087 11.7237 18.6754C11.6403 18.6421 11.557 18.5837 11.4737 18.5004L8.24866 15.2754Z",
    fill: "#535B5F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDown);
export default __webpack_public_path__ + "static/media/sort_down.24e0f6c7a4b6823669e3766a77f21348.svg";
export { ForwardRef as ReactComponent };